import { useRef } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import NotionRenderer from '../components/NotionRenderer';
import ReadingProgress from '../components/ReadingProgress';
import useTitle from '../lib/useTitle';
import { findBlog, formatDate, isPublished, readingTime } from '../lib/blogs';
import { profile } from '../lib/profile';
import './BlogPage.css';

function BackLink() {
  return (
    <Link className="article__back" to="/blog">
      <ArrowLeft size={14} aria-hidden="true" /> Back to writing
    </Link>
  );
}

export default function BlogPage() {
  const { id } = useParams();
  const blog = findBlog(id);
  const articleRef = useRef(null);
  useTitle(blog?.title);

  if (!blog) return <Navigate to="/blog" replace />;

  if (!isPublished(blog)) {
    return (
      <main id="content" className="article">
        <div className="article__layout">
          <div className="article__inner">
            <BackLink />
            <p className="article__meta">
              <span className="article__date">in progress</span>
            </p>
            <h1 className="article__title">{blog.title}</h1>
            <p className="article__abstract">
              This article is still being written. Check back later.
            </p>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main id="content" className="article">
      <div className="article__layout">

        <div className="article__inner" ref={articleRef}>
          <ReadingProgress target={articleRef} />
          <BackLink />
          <header className="article__head">
            <p className="article__meta">
              <time className="article__date" dateTime={blog.publishDate}>
                {formatDate(blog.publishDate, 'long')}
              </time>
              <span>{profile.name}</span>
              <span>{readingTime(blog.blocks)} min read</span>
            </p>
            <h1 className="article__title">{blog.title}</h1>
          </header>

          {blog.image && (
            <div className="article__cover mono">
              <img src={blog.image} alt="" />
            </div>
          )}

          <NotionRenderer blocks={blog.blocks} />

          <div className="article__end">
            <BackLink />
          </div>
        </div>
      </div>
    </main>
  );
}
